import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria';
import { TABLE_PAGE_SIZE } from '../../config';
import type { DefaultTableCriteria } from '../../utils/useListCriteria';

export const defaultCriteria: DefaultTableCriteria<'providers'> = {
  [CriteriaDimension.FILTERS]: {
    phrase: '',
  },
  [CriteriaDimension.PAGINATION]: {
    pageNumber: 1,
    pageSize: TABLE_PAGE_SIZE,
    totalCount: 100,
  },
  [CriteriaDimension.SORT]: {
    column: 'name',
    direction: SortDirection.ASC,
    sortableColumns: ['name'],
  },
};
